"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAirportCodeFromMainText = extractAirportCodeFromMainText;
exports.mapPlaceAutocompleteResultToLocation = mapPlaceAutocompleteResultToLocation;
exports.mapNewPlacesAutocompleteToLocation = mapNewPlacesAutocompleteToLocation;
exports.filterOutNotSpecificEnoughPlaceTypes = filterOutNotSpecificEnoughPlaceTypes;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const google_maps_place_types_1 = require("./google-maps-place-types");
function getLocationTypeFromGoogleLocation(googleLocationTypes = []) {
    if (googleLocationTypes.includes(google_maps_place_types_1.PlaceType1.airport)) {
        return "airport";
    }
    if (googleLocationTypes.includes(google_maps_place_types_1.PlaceType1.lodging)) {
        return "hotel";
    }
    if (googleLocationTypes.includes(google_maps_place_types_1.PlaceType2.locality)) {
        return "city";
    }
    if (googleLocationTypes.includes(google_maps_place_types_1.PlaceType2.street_address)) {
        return "street";
    }
    return "unspecified";
}
/**
 * Airports in Google Places tend to have the airport code
 * in parentheses at the end of the main text (e.g. "Some airport (ABC)").
 * */
function extractAirportCodeFromMainText(mainText, types) {
    const airportCodes = [];
    let mainTextWithoutAirportCode = mainText;
    if (types?.includes(google_maps_place_types_1.PlaceType1.airport)) {
        const airportCodeMatch = mainText.match(/\(([^)]+)\)/);
        if (airportCodeMatch) {
            mainTextWithoutAirportCode = mainText.replace(airportCodeMatch[0], "").trim();
            airportCodes.push(airportCodeMatch[1]);
        }
    }
    return {
        airportCodes,
        mainTextWithoutAirportCode,
    };
}
function mapPlaceAutocompleteResultToLocation(place) {
    const { mainTextWithoutAirportCode, airportCodes } = extractAirportCodeFromMainText(place.structured_formatting.main_text, place.types);
    return {
        _id: place.place_id,
        mainText: mainTextWithoutAirportCode,
        secondaryText: place.structured_formatting.secondary_text,
        source: legacy_enums_1.LocationSource.Google,
        locationType: getLocationTypeFromGoogleLocation(place.types),
        airportCodes,
    };
}
function mapNewPlacesAutocompleteToLocation(place) {
    const { mainTextWithoutAirportCode, airportCodes } = extractAirportCodeFromMainText(place.structuredFormat.mainText.text, place.types);
    return {
        _id: place.placeId,
        mainText: mainTextWithoutAirportCode,
        secondaryText: place.structuredFormat.secondaryText?.text ?? "",
        source: legacy_enums_1.LocationSource.Google,
        locationType: getLocationTypeFromGoogleLocation(place.types),
        airportCodes,
    };
}
/**
 * Sometimes we want to allow the user to only select place types
 * which we deem to be "specific enough" for a driver to be able
 * to find and pick them up from. For example, we might want to
 * filter out entire cities, and allow for more specific addresses
 * or establishments, tourist attractions, etc. to be selected.
 * */
function filterOutNotSpecificEnoughPlaceTypes(place) {
    return place.locationType !== "city";
}
//# sourceMappingURL=map-place-autocomplete-result-to-location.js.map